export const CURVE_RETRIEVED = 'CURVE_RETRIEVED';

export interface NotificationMessage {
  readonly type: typeof CURVE_RETRIEVED;
  readonly opportunityId: string;
}
